import { ActionTree } from 'vuex';

// Shared types
import { ApiMapResponse, AdditionalProduct, ServiceProduct } from '@coldtec/cos-types';

/// Store and store types
import Store from '@/store';
import {
    RootState,
    ProductsAction,
    ProductsMutation,
    ProductsGetter,
    ToolProducts,
    RequestAction,
} from '@/store/store.types';

// Api
import Api from '@/api';

/**
 *  Holding the actions of the products.
 */
export const Actions: ActionTree<RootState, RootState> = {

    /**
     *  Used to fetch and store the additional products.
     */
    async [ProductsAction.FETCH_ADDITIONAL]({ commit }): Promise<void> {

        const { data } = await Api.client.get<ApiMapResponse<AdditionalProduct>>('/products/additional');

        commit(ProductsMutation.ADDITIONAL, data.map);

        return Promise.resolve();

    },

    /**
     *  Used to fetch and store the service products.
     */
    async [ProductsAction.FETCH_SERVICE]({ commit }): Promise<void> {

        const { data } = await Api.client.get<ApiMapResponse<ServiceProduct>>('/products/service');

        commit(ProductsMutation.SERVICE, data.map);

        return Promise.resolve();

    },

    /**
     *  Used to sync the spaces of the request with the tool spaces.
     */
    async [ProductsAction.SYNC_FROM_REQUEST]({ state }): Promise<void> {

        /**
         *  Sync the additional products.
         */
        for (const addedAdditionalProduct of state.request.data.additional_products) {

            for (const additionalProduct of state.products.additional) {

                if (addedAdditionalProduct.guid !== additionalProduct.guid) {

                    continue;

                }

                additionalProduct.selected = true;
                additionalProduct.amount = addedAdditionalProduct.amount;
                additionalProduct.price = addedAdditionalProduct.price;

                break;

            }

        }

        /**
         *  Sync the service products.
         */
        for (const addedServiceProductGuid of state.request.data.service_products) {

            for (const serviceProduct of state.products.service) {

                if (addedServiceProductGuid !== serviceProduct.guid) {

                    continue;

                }

                serviceProduct.selected = true;

                break;

            }

        }

    },

    /**
     *
     *  Used to toggle the selected state of the product with the forwarded guid.
     *
     *  @param productGuid The guid of the product to toggle the selected state from
     *
     */
    async [ProductsAction.TOGGLE_SELECTED]({ commit, dispatch }, productGuid: string): Promise<void> {

        for (const product of Store.getters[ProductsGetter.ALL] as ToolProducts) {

            if (product.guid === productGuid) {

                commit(ProductsMutation.TOGGLE_SELECTED, {
                    [product.guid]: !product.selected,
                });

                break;

            }

        }

        /**
         *  Dispatch an action to sync the request products.
         */
        dispatch(RequestAction.SYNC_PRODUCTS);

    },

};
